import { Button, DatePicker, Form, Input, Select } from "antd"
import {
    PlusOutlined,
} from '@ant-design/icons';
import locale from 'antd/locale/zh_CN';

import { STATUS_DICT } from "../dict";

const UserOperationBar = props => {
    const { form, query } = props
    const { setQuery, onCreate } = props

    const handleOnCreateUser = () => {
        if (typeof onCreate === 'function') onCreate()
    }
    const handleOnSearch = () => {
        let formData = form.getFieldsValue()
        if (!!formData.lastLoginDate?.length) {
            formData.lastLoginDate = formData.lastLoginDate.map(
                (itm, idx) => itm.format('YYYY-MM-DD') + (!idx ? ' 00:00:00' : ' 23:59:59')
            )
        }
        setQuery({ ...query, ...formData })
    }

    return <div className="user-mng-operation-container">
        <Form
            layout='inline'
            form={form}
            autoComplete='off'
        >
            <Form.Item>
                <Button
                    icon={<PlusOutlined />}
                    onClick={handleOnCreateUser}
                >
                    创建新用户
                </Button>
            </Form.Item>
            <Form.Item name="nickName">
                <Input placeholder="用户名称" />
            </Form.Item>
            <Form.Item name="phone">
                <Input placeholder="用户手机号" />
            </Form.Item>
            <Form.Item name="status">
                <Select
                    placeholder="用户状态"
                    options={STATUS_DICT}
                    allowClear
                    style={{ width: 100 }}
                />
            </Form.Item>
            <Form.Item name="lastLoginDate">
                <DatePicker.RangePicker
                    locale={locale}
                    placeholder={['最后登录-起', '最后登录-止']}
                    format='YYYY-MM-DD'
                />
            </Form.Item>
            <Form.Item>
                <Button
                    type="primary"
                    onClick={handleOnSearch}
                >
                    查询
                </Button>
            </Form.Item>
        </Form>
    </div>
}

export default UserOperationBar
